<div
  *ngIf="currentDashboard"
  class="dashboard-container d-flex fd-col jc-start ai-stretch"
>
  <suvo-bi-smart-grid
    [settings]="gridSettings"
    [grid]="currentDashboard"
    [editMode]="editMode"
    [displayNameLabel]="displayNameLabel"
    [saveChangesAsync]="saveChangesAsync"
    [isCreation]="isCreation"
    [scrollEnabled]="editMode"
    (onCreate)="createDashboard($event)"
    (contentChanged)="gridContentChanged($event)"
  >
    <ng-template let-tileDefinition>
      <suvo-bi-tile-wrapper
        class="dashboard-tile flex-1"
        [tileInstance]="tileDefinition"
        [filtersChannel]="filtersChannel"
        [editMode]="editMode"
      />
    </ng-template>
  </suvo-bi-smart-grid>
</div>
